import deleteCookie from './deleteCookie';
import getCookie from './getCookie';
import setCookie from './setCookie';

export default { setCookie, deleteCookie, getCookie };
